<script setup lang="ts">
import { authenticateLogin } from "@/login";
import { useRoute } from "vue-router";

const route = useRoute();
const code = (route.query?.code as string) || "";

await authenticateLogin(code);

console.log(`redirecting to search page`);

window.location.replace("/");
</script>
